var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_247_787)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM6.00004 6.7083C4.75529 8.11858 4 9.97108 4 12C4 15.8818 6.76473 19.1179 10.4325 19.8465L10.6831 19.1781C11.1881 17.8316 10.9314 16.3177 10.0108 15.213L9.46352 14.5561C9.16403 14.1967 9.00001 13.7437 9.00001 13.2758V13.0702C9.00001 12.4015 8.66584 11.7771 8.10948 11.4061L7.78092 11.1871C6.66827 10.4453 5.99995 9.19664 6 7.85935L6.00004 6.7083ZM14.7727 19.5065C17.8244 18.3788 20 15.4435 20 12C20 9.12417 18.2838 6.48234 16 5L13.3867 9.41954C13.1451 9.78196 12.7383 9.99964 12.3028 9.99964C11.5833 9.99964 11 10.5829 11 11.3024V13.0104C11 13.4513 11.4763 13.7277 11.8591 13.509C13.5666 12.5333 15.2823 13.0432 16.3249 14.4332L16.594 14.7921C17.1289 15.5053 17.1203 16.4882 16.573 17.1918L14.7727 19.5065Z",
    fill: "#97A0A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_247_787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLang);
export default __webpack_public_path__ + "static/media/Lang.05ab66dfd37c5a989a65574c2c89efd3.svg";
export { ForwardRef as ReactComponent };